<script setup lang="ts">
defineOptions({ inheritAttrs: false });
const props = defineProps({
    typeLoading: {
        type: Array<string>,
        default: ['card-avatar', 'article', 'actions'],
    },
})
</script>

<template>
  <div>
    <VSkeletonLoader
      class="mx-auto"
      max-width="80%"
      :type="props.typeLoading"
    ></VSkeletonLoader>
  </div>
</template>
